<template>
  <Header />
  <RegisterRole />
  <Footer />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import RegisterRole from "@/components/RegisterRole.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

onMounted(() => {
  document.title = "ElevatED – Register Role";
});
</script>
